export default __webpack_public_path__ + "static/media/onedrive.cb5bc446.svg";